import { FabricObject, classRegistry } from "fabric";
import { COLOR_DEFAULT, COLOR_FOCUSED } from "./camera-icons";

const MEMO_SIZE = 24;
const MEMO_HALF = MEMO_SIZE / 2;
const MEMO_RADIUS = 4;
const MEMO_FILL = "rgba(255, 255, 255, 0.48)";
const MEMO_STROKE_WIDTH = 2;
const MEMO_ICON_SIZE = 14;
const MEMO_ICON_HALF = MEMO_ICON_SIZE / 2;

// 메모 아이콘 SVG (Figma 기준) — 색상 파라미터로 동적 생성
function createMemoIcon(color: string): HTMLImageElement {
  const svg = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 16H0V0H16V16ZM3.2002 10.4004V12H12.8008V10.4004H3.2002ZM3.2002 7.2002V8.7998H12.8008V7.2002H3.2002ZM3.2002 4V5.60059H9.60059V4H3.2002Z" fill="${color}"/>
</svg>`;
  const img = new Image();
  img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  return img;
}

const MEMO_ICON_DEFAULT = createMemoIcon(COLOR_DEFAULT);
const MEMO_ICON_FOCUSED = createMemoIcon(COLOR_FOCUSED);

interface MemoMarkerOptions {
  memoId: number;
  cameraId: number;
  left: number;
  top: number;
  isFocused?: boolean;
}

export class MemoMarker extends FabricObject {
  declare memoId: number;
  declare cameraId: number;
  declare isFocused: boolean;

  constructor(options: MemoMarkerOptions) {
    super({
      width: MEMO_SIZE,
      height: MEMO_SIZE,
      originX: "center",
      originY: "center",
      left: options.left,
      top: options.top,
      selectable: true,
      hasControls: false,
      hasBorders: true,
      lockRotation: true,
      lockScalingX: true,
      lockScalingY: true,
      objectCaching: false,
    });
    this.memoId = options.memoId;
    this.cameraId = options.cameraId;
    this.isFocused = options.isFocused ?? false;
  }

  _render(ctx: CanvasRenderingContext2D): void {
    const color = this.isFocused ? COLOR_FOCUSED : COLOR_DEFAULT;

    // 라운드 사각형 배경
    ctx.beginPath();
    ctx.roundRect(-MEMO_HALF, -MEMO_HALF, MEMO_SIZE, MEMO_SIZE, MEMO_RADIUS);
    ctx.fillStyle = MEMO_FILL;
    ctx.fill();
    ctx.strokeStyle = color;
    ctx.lineWidth = MEMO_STROKE_WIDTH;
    ctx.stroke();

    // 메모 아이콘
    const icon = this.isFocused ? MEMO_ICON_FOCUSED : MEMO_ICON_DEFAULT;
    ctx.drawImage(icon, -MEMO_ICON_HALF, -MEMO_ICON_HALF, MEMO_ICON_SIZE, MEMO_ICON_SIZE);
  }

  updateAppearance(options: { isFocused?: boolean }): void {
    if (options.isFocused !== undefined) this.isFocused = options.isFocused;
  }
}

classRegistry.setClass(MemoMarker, "MemoMarker");
